// extracted by mini-css-extract-plugin
export default {"header":"ValueScreen_header__TwHW6"};